export default __webpack_public_path__ + "static/icon_happy-b7febf12944e80ddaf24841f45da14e4.png";